module.exports = __webpack_public_path__ + "images/touch-icon-ipad-retina.60c7f3ab47f87d84e49c28de969469fe.png";